
<template>
	<div>
		<div class="tasks-items">
			<div v-for="task in tasks" class="task-item" :class="{'task-done':task.done}" :data-task-id="task.id"  @mousedown="mousedownTasks(task,$event)">
				<h4>{{ task.name }}</h4>
				<p>{{ task.description }}</p>
				<div class="task-footer">
					<span class="task-checkbox" :class="{'checked':task.done}" @click.stop="toggleDone(task)"><i>✔</i></span>
					<label class="task-due" @click.stop @mousedown.stop>
						<i><svg viewBox="0 0 24 24"><path fill="#000000" d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z" /></svg></i>
						<span v-if="task.due">{{ formatDue(task.due) }}</span>
						<ins v-if="task.overdue && !task.done"><svg viewBox="0 0 24 24"><path fill="#000000" d="M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22A9,9 0 0,0 21,13A9,9 0 0,0 12,4M12.5,8H11V14L15.75,16.85L16.5,15.62L12.5,13.25V8M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72Z" /></svg></ins>
						<div @click.stop.prevent @mousedown.stop.prevent>
							<datetime @close="setDue(task)" v-model="task.due" value-zone="local" type="datetime" :minute-step="5" auto title="Selecionar data" :phrases="{ok: 'Ok', cancel: 'Cancelar'}"></datetime>
						</div>
					</label>
					<div class="task-buttons">
						<span class="task-button-editar" @click="formTaskEdit(task)"><i><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z" /></svg></i></span>
						<span class="task-button-delete" @click="onDelete(task)"><i><svg viewBox="-40 0 427 427.00131" xmlns="http://www.w3.org/2000/svg"><path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0"/><path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/></svg></i></span>
						<span class="task-button-mover" @touchstart.prevent="mousedownTasks(task,$event)"><i><svg viewBox="0 0 24 24"><path d="M7,19V17H9V19H7M11,19V17H13V19H11M15,19V17H17V19H15M7,15V13H9V15H7M11,15V13H13V15H11M15,15V13H17V15H15M7,11V9H9V11H7M11,11V9H13V11H11M15,11V9H17V11H15M7,7V5H9V7H7M11,7V5H13V7H11M15,7V5H17V7H15Z" /></svg></i></span>
					</div>
				</div>

				<em :style="{backgroundColor:'#'+task.theme}"></em>
			</div>
		</div>
	</div>
</template>

<style>
.tasks-items{}
.task-item { position: relative; background:rgba(242, 242, 242, 0.9);  margin-bottom:6px; padding-right:10px;
  width:100%;
  border-radius: 10px;
  overflow: hidden;
  cursor: grab;
  user-select: none;
  box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.15);
}
.task-item:active {
  cursor: grabbing;
}

.task-item h4 {
  font-size:.8em; color:#333; font-weight: 500;  padding:5px 10px; border-bottom:1px solid #999;
white-space: nowrap;
overflow: hidden;text-overflow: ellipsis;
}
.task-item p {
  color:#333;
  font-size:.8em;
  padding:5px 5px 5px 10px;
  margin:0;
  overflow-y: auto;
  max-height: 46px;
 }

.task-item.task-done h4 {text-decoration: line-through;}
.task-item.task-done p {text-decoration: line-through;}
.task-item.task-done .task-due > span {text-decoration: line-through;}


.task-item p::-webkit-scrollbar{width: 6px; /*background-color: #F5F5F5;*/ }
.task-item p::-webkit-scrollbar-track {/*background-color: #F5F5F5;*/ }
.task-item p::-webkit-scrollbar-thumb {background-color: transparent; /*border: 2px solid #555555;*/ }
.task-item p:hover::-webkit-scrollbar-thumb {background-color: #aaa; border-radius:3px; /*border: 2px solid #555555;*/ }


.task-item em { position: absolute; top:0;bottom:0;right:0;width:10px;}
.task-footer { display: flex; padding:5px 5px 5px 10px; align-items: center; border-top:1px solid #999; }

.task-checkbox { cursor:default; width:16px; height:16px; display: inline-block; border:2px solid #ccc; border-radius:5px; background-color:#fff; margin-right: 5px; }
.task-checkbox i { opacity:0; content:"\2714"; color:#2cc6ba; font-size:14px; display: block; text-align: center; line-height: 14px; }
.task-checkbox.checked i { opacity:1 }

.task-due { color:#333; flex-grow: 1; font-size:12px; line-height: 16px; cursor: pointer; }
.task-due i { vertical-align:middle; display:inline-block; margin-right: 3px; width:15px; height:15px; }
.task-due svg { display: block; width:100%; height:100%; }
.task-due svg path{ fill:#333;}
.task-due ins { display:inline-block; color:red; width:15px; height:15px;  vertical-align: -2px; margin-left: 2px; }
.task-due ins svg {display: block; width:100%; height:100%; }
.task-due ins svg path { fill:#c00; }

.task-due input { display: none }

.task-due .vdatetime-popup__header,
.task-due .vdatetime-calendar__month__day--selected > span > span,
.task-due .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #1cc4cf;
}
.task-due .vdatetime-year-picker__item--selected,
.task-due .vdatetime-time-picker__item--selected,
.task-due .vdatetime-popup__actions__button {
  color: #1cc4cf;
}

.task-buttons {  }
.task-buttons span { margin:0 2px; padding:2px; height:16px; line-height: 1; cursor: pointer; }
.task-buttons i { display:inline-block; width:10px; height:10px; }
.task-buttons svg { display: block; width:100%; height:100%; }
.task-buttons svg path{ fill:#333;}
.task-button-editar { display: inline-block; }

.task-button-mover { display: none; }
.task-button-mover svg {  width:110%; height:110%; }


.task-item.placeholder { background:none; border: 2px dashed #1cc4cf; transition: transform 0.2s; }
.task-item.dragging {
  position: fixed;
  box-shadow: 5px 5px 5px rgba(0,0,0,.2);
  z-index: 2;
  transform: rotate(-2deg);
  /*background: #1cc4cf; */
}

body.is-mobile .task-buttons { display: flex;  }
body.is-mobile .task-buttons span { display: block; padding: 9px; height: 35px; }
body.is-mobile .task-buttons i { width:15px; height:15px; }
body.is-mobile .task-buttons .task-button-mover { padding:5px; }
body.is-mobile .task-buttons .task-button-mover i {width:21px; height:21px; }
body.is-mobile .task-item h4 { font-size:1em; }
body.is-mobile .task-item p { font-size:1em; }
body.is-mobile .task-due { font-size:14px; line-height: 19px;  }
body.is-mobile .task-due i {width:18px; height:18px;}
body.is-mobile .task-checkbox { width:20px; height:20px;  }
body.is-mobile .task-checkbox i { font-size:16px; line-height: 18px; }


</style>

<script>

	import firebase from '@/firebase'
	import { Datetime } from 'vue-datetime';



	export default {
		components: {
			datetime: Datetime
		},
		computed:{
			user(){
				return this.$store.getters.user;
			},
			userId(){
				return this.$store.getters.userId;
			},
			config(){
				return this.$store.state.config;
			},
			preferences(){
				return this.$store.getters.preferences;
			},
			tasks(){
				return this.$store.getters.orderedTasks;
			},
		},
		data() {
			return {
				dndTasks:{
					mouseDown:false,
					dragging:false,
					task:null,
					element:null,
					offset:{x:0, y:0, },
					mouse:{x:0, y:0, },
					indexHover:null,
				},

				db:null,
			}
		},
		methods:{
			setDue(task){
				if(!task.due) task.due = null;
				this.$store.dispatch('updateTask',{task_id:task.id,data:{due:task.due}})
			},
			formatDue(datetime){
				if(!datetime) return datetime;
				var date = new Date(datetime);
				var val = {
					h: date.getHours(),
					i: date.getMinutes(),
					d: date.getUTCDate(),
					m: date.getUTCMonth() + 1,
					yy: date.getUTCFullYear().toString().substring(2),
					yyyy: date.getUTCFullYear()
				}
				val.mm = (val.m < 10 ? '0' : '') + val.m;
				val.dd = (val.d < 10 ? '0' : '') + val.d;
				val.hh = (val.h < 10 ? '0' : '') + val.h;
				val.ii = (val.i < 10 ? '0' : '') + val.i;

				return val.dd+'/'+val.mm+' '+val.hh+':'+val.ii;
			},

			formTaskEdit(task){
				this.$router.push({name:'formTask',params:{item:task}})
			},
			onDelete(task){
				if(!confirm('Tem certeza?')) return;
				this.$store.dispatch('deleteTask',{task_id:task.id});
			},
			toggleDone(task){
				task.done = !task.done
				this.$store.dispatch('updateTask',{task_id:task.id,data:{done:task.done}})
			},


			getIndexHover(y){
				var indexHover = null;
				var tasks = this.tasks;
				var index;
				for (index in tasks){
					if(tasks[index].id == this.dndTasks.element.getAttribute('data-task-id')) continue;
					var rect = document.querySelector('.task-item[data-task-id="'+tasks[index].id+'"]').getBoundingClientRect();
					if(y <= rect.y) return tasks[index].index;
					if(y >= rect.y && y <= rect.y+rect.height/2) return tasks[index].index;
					if(y >= rect.y+rect.height/2 && y <= rect.y+rect.height) return tasks[index].index+1;
				}
				return null
			},

			mousedownTasks(task,e){
				if(e.type=='touchstart'){
					var target = document.querySelector('.task-item[data-task-id="'+task.id+'"]');
					var coords = {
						x:e.touches[0].pageX,
						y:e.touches[0].pageY,
					}
					var rect = target.getBoundingClientRect();
					var offset = {
						x:e.targetTouches[0].clientX - rect.left,
						y:e.targetTouches[0].clientY - rect.top,
					}
				} else {
					var coords = {
						x:e.clientX,
						y:e.clientY,
					}
					var offset = {
						x:e.offsetX,
						y:e.offsetY,
					}
				}


				this.dndTasks.task = task;
				this.dndTasks.element = document.querySelector('.task-item[data-task-id="'+task.id+'"]');
				console.log('task',task);
				console.log('elemen',this.dndTasks.element);
				this.dndTasks.offset.x = offset.x;
				this.dndTasks.offset.y = offset.y;

     		//record coordinates to start draggin 10px after this
     		this.dndTasks.mouse.x = coords.x;
     		this.dndTasks.mouse.y = coords.y;

     		this.dndTasks.mouseDown = true;

     	},

     	mousemoveTasks(coords){
     		var movePlaceholder = false;
     		if(!this.dndTasks.dragging){
     			if(Math.abs(this.dndTasks.mouse.x-coords.x)<10 && Math.abs(this.dndTasks.mouse.y-coords.y)<10) return;
     			this.dndTasks.dragging = true;
     			this.dndTasks.element.style.width = this.dndTasks.element.offsetWidth+'px';
     			this.$nextTick(()=>{
     				this.dndTasks.element.classList.add('dragging');
     			})
     			movePlaceholder = true;
     		}

     		this.dndTasks.element.style.left = (coords.x - this.dndTasks.offset.x) + 'px';
     		this.dndTasks.element.style.top = (coords.y - this.dndTasks.offset.y) + 'px';



     		var indexHover = this.getIndexHover(coords.y);
     		if(indexHover && this.dndTasks.indexHover!=indexHover){
     			console.log('change index ',indexHover);
     			this.dndTasks.indexHover = indexHover;
     			movePlaceholder = true;
     		}

     		if(movePlaceholder) {
	        //remove existing placeholder
	        document.querySelectorAll('.placeholder').forEach((placeholder) => { placeholder.parentNode.removeChild(placeholder); });

	        //create new placeholder
	        var placeholder = document.createElement('div');
	        placeholder.className = 'task-item placeholder';
	        placeholder.style.height = this.dndTasks.element.offsetHeight+'px';

	        //insert on chosen position
	        var tasks = this.tasks.filter(task => task.index==this.dndTasks.indexHover);
	        if(tasks.length){
	        	var taskElement = document.querySelector('.task-item[data-task-id="'+tasks[0].id+'"]');
	        	taskElement.parentNode.insertBefore(placeholder,taskElement);
	        } else {
	        	document.querySelector('.tasks-items').appendChild(placeholder);
	        }
	      }
	    },

	    mouseupTasks(e){
	    	this.dndTasks.dragging = false;
	    	this.dndTasks.task.index= this.dndTasks.indexHover-0.5;

	      //atualizar index dos demais elementos
	      this.$store.dispatch('changeTaskOrder',{task_id:this.dndTasks.task.id,index:this.dndTasks.task.index});

	      this.dndTasks.element.style.width='';
	      this.dndTasks.element.style.top='';
	      this.dndTasks.element.style.left='';
	      this.dndTasks.element.classList.remove('dragging');

	      //remove placeholder
	      document.querySelectorAll('.placeholder').forEach((placeholder) => { placeholder.parentNode.removeChild(placeholder); })
	    },

	  },
	  created(){

	  	setInterval(()=>{
	  		this.$store.dispatch('checkTasksOverdue');
	  	},1000*60);

	  	this.db = firebase.firestore();



			document.querySelector('body').addEventListener('mousemove',(e)=>{
				var coords={x:e.clientX, y:e.clientY, }
				if(this.dndTasks.mouseDown) return this.mousemoveTasks(coords);
			});

			document.querySelector('body').addEventListener('touchmove',(e)=>{
				var coords={x:e.touches[0].clientX, y:e.touches[0].clientY, }
				if(this.dndTasks.mouseDown) return this.mousemoveTasks(coords);
			},{passive:false});

			document.querySelector('body').addEventListener('mouseup',(e)=>{
	  		this.dndTasks.mouseDown = false;
	  		if(this.dndTasks.dragging) return this.mouseupTasks(e);
			});
			document.querySelector('body').addEventListener('touchend',(e)=>{
	  		this.dndTasks.mouseDown = false;
	  		if(this.dndTasks.dragging) return this.mouseupTasks(e);
			});
	  }

	}

</script>

